/*
* Broadcast Theme
*
* Use this file to add custom JavaScript to Broadcast. Keeping your custom
* JavaScript in this file will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  document.documentElement.style.visibility = 'hidden'; // Hide entire page initially

  document.addEventListener('DOMContentLoaded', function() {
    console.log("Scripts loaded successfully!");

    // 1. Force accordion for desktop footer menus
    document.querySelectorAll(".footer__block--menu").forEach(footerMenu => {
      footerMenu.setAttribute("desktop", "true");
      footerMenu.removeAttribute("disabled");
      footerMenu.open = false;
    });

    console.log("Footer accordion script ran successfully!");

    // 2. Force accordion for Newsletter
    const newsletterBlock = document.querySelector(".footer__block--newsletter");

    if (newsletterBlock) {
      console.log("Newsletter block found!");
      
      const details = document.createElement("details");
      details.classList.add("footer__block", "footer__block--menu", "accordion");
      details.style.setProperty("--desktop-width", "22%");

      const summary = document.createElement("summary");
      summary.classList.add("h5", "footer__block__title", "accordion__title");
      summary.setAttribute("data-collapsible-trigger", "");
      summary.setAttribute("tabindex", "0");
      summary.innerHTML = `
        NEWSLETTER
        <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 24 24">
          <path d="M6 12h6m6 0h-6m0 0V6m0 6v6" stroke="#000" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
        <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" viewBox="0 0 24 24">
          <path d="M6 12h12" stroke="#000" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
      `;

      const existingTitle = newsletterBlock.querySelector(".footer__block__title");
      if (existingTitle) existingTitle.remove();

      const contentWrapper = document.createElement("div");
      contentWrapper.classList.add("accordion__content");
      contentWrapper.setAttribute("data-collapsible-content", "");
      contentWrapper.style.maxHeight = "0";
      contentWrapper.style.overflow = "hidden";
      contentWrapper.style.transition = "max-height 0.3s ease-out, opacity 0.3s ease-out";
      contentWrapper.style.opacity = "0";

      contentWrapper.appendChild(newsletterBlock.cloneNode(true));
      details.appendChild(summary);
      details.appendChild(contentWrapper);

      newsletterBlock.parentNode.insertBefore(details, newsletterBlock);
      newsletterBlock.remove();

      summary.addEventListener("click", function (event) {
        event.preventDefault();

        const isOpen = details.hasAttribute("open");
        const plusIcon = summary.querySelector(".icon-plus");
        const minusIcon = summary.querySelector(".icon-minus");

        document.querySelectorAll(".footer__block--menu.accordion[open]").forEach((openDetails) => {
          if (openDetails !== details) {
            openDetails.removeAttribute("open");
            const openContent = openDetails.querySelector("[data-collapsible-content]");
            openContent.style.maxHeight = "0";
            openContent.style.opacity = "0";
            openDetails.querySelector(".icon-plus").style.visibility = "visible";
            openDetails.querySelector(".icon-plus").style.opacity = "1";
            openDetails.querySelector(".icon-minus").style.visibility = "hidden";
            openDetails.querySelector(".icon-minus").style.opacity = "0";
          }
        });

        if (isOpen) {
          details.removeAttribute("open");
          contentWrapper.style.maxHeight = "0";
          contentWrapper.style.opacity = "0";
          plusIcon.style.visibility = "visible";
          plusIcon.style.opacity = "1";
          minusIcon.style.visibility = "hidden";
          minusIcon.style.opacity = "0";
        } else {
          details.setAttribute("open", "");
          contentWrapper.style.maxHeight = contentWrapper.scrollHeight + "px";
          contentWrapper.style.opacity = "1";
          plusIcon.style.visibility = "hidden";
          plusIcon.style.opacity = "0";
          minusIcon.style.visibility = "visible";
          minusIcon.style.opacity = "1";
        }
      });
    }

    console.log("Newsletter script ran successfully!");

    // 3. Remove top sections on paginated pages before they render
    var urlParams = new URLSearchParams(window.location.search);
    var pageNum = parseInt(urlParams.get('page'), 10) || 1;

    if (pageNum > 1) {
      console.log("Pagination detected, removing sections before rendering...");
      
      var sectionsToRemove = document.querySelectorAll("[data-section-type='columns'], [data-section-type='custom-content'], [data-section-type='hero'], [data-section-type='rich-text'], [data-section-type='featured-video'], [data-section-type='double'], [data-section-type='custom-code']");

      sectionsToRemove.forEach(function(section) {
        section.remove(); // Completely remove from the DOM
      });

      console.log("Sections removed before rendering!");
    } else {
      console.log("Not a paginated page, no sections removed.");
    }

    document.documentElement.style.visibility = 'visible'; // Show page after sections are removed
  });

})();